import React from "react";
import clsx from "clsx";
import { UseFormRegisterReturn } from "react-hook-form";

type InputProps = {
  labelName?: string;
  className?: string;
  registration?: Partial<UseFormRegisterReturn>;
  error?: boolean;
  value?: string | number;
  name?: string;
  defaultValue?: string;
  hidden?: boolean;
  handleChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const TextArea = ({
  labelName,
  className,
  registration,
  error,
  value,
  name,
  hidden,
  defaultValue,
  handleChange,
}: InputProps) => {
  return (
    <>
      {labelName && (
        <label className="text-[18px] text-[#333333] block font-dmSans pb-1 dark:text-white">
          {labelName}
        </label>
      )}
      <div className="flex flex-row relative">
        <textarea
          value={value && value}
          defaultValue={defaultValue && defaultValue}
          name={name && name}
          hidden={hidden && hidden}
          className={clsx(
            `rounded-lg min-h-[90px] bg-[#f7f7f7] focus:outline-none w-full p-2  dark:bg-darkGray dark:text-white leading-[1.2] ${
              !error
                ? "mb-6 border border-transparent"
                : "border border-rose-500"
            }`,
            className
          )}
          {...registration}
          onChange={handleChange && handleChange}
          cols={10}
        ></textarea>
      </div>
    </>
  );
};
